import React from "react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

const BenefitsList = ({ benefits }) => {
  const { t } = useTranslation()

  return (
    <ul className="benefits">
      {benefits.map(benefit => (
        <li key={benefit.title} className="benefits-item">
          <p className="mb-0 benefits-item__title">{t(benefit.title)}</p>
          <p className="mb-8">{t(benefit.description)}</p>
        </li>
      ))}
    </ul>
  )
}

export default BenefitsList
